export default __webpack_public_path__ + "static/media/iPhone-Premium-1.afb01fb6.png";